import BaseObject from 'app/src/base/BaseObject';
import TerminalFactory from 'app/src/payments/terminals/TerminalFactory';
import TyroTerminalService from 'app/src/payments/terminals/TyroTerminalService';
import StripeTerminalService from 'app/src/payments/terminals/StripeTerminalService';
import CommonData from 'app/src/data/CommonData';
import CCTerminalCollection from 'app/src/data/models/CCTerminalCollection';
import CCTerminal from 'app/src/data/models/CCTerminal';
import GatewayConfig from 'app/src/data/models/GatewayConfig';
import PaymentTypeManager from 'app/src/payments/PaymentTypeManager.js';
import Modules from 'shared_modules/Modules';

import find from 'lodash/find';
import get from 'lodash/get';
import isUndefined from 'lodash/isUndefined';
import $ from 'jquery';

/*
Maintains the lists of supported terminals for each gateway type
 */
const _SupportedTerminals = {};
_SupportedTerminals[GatewayConfig.GatewayType.CAYAN] = [CCTerminal.TerminalType.GENIUS];
_SupportedTerminals[GatewayConfig.GatewayType.FIRST_DATA] = [CCTerminal.TerminalType.BLACKLINE];
_SupportedTerminals[GatewayConfig.GatewayType.LIGHTSPEED_PAYMENTS] = [
  CCTerminal.TerminalType.LIGHTSPEED,
];
_SupportedTerminals[GatewayConfig.GatewayType.MERCURY_CANADA] = [CCTerminal.TerminalType.BLACKLINE];
_SupportedTerminals[GatewayConfig.GatewayType.MERCURY_EMV] = [CCTerminal.TerminalType.BLACKLINE];
_SupportedTerminals[GatewayConfig.GatewayType.VANTIV_CANADA] = [CCTerminal.TerminalType.BLACKLINE];
_SupportedTerminals[GatewayConfig.GatewayType.VANTIV_TRIPOS] = [CCTerminal.TerminalType.TRIPOS];
_SupportedTerminals[GatewayConfig.GatewayType.VANTIV_US] = [CCTerminal.TerminalType.BLACKLINE];
_SupportedTerminals[GatewayConfig.GatewayType.TYRO] = [
  CCTerminal.TerminalType.YOXIMO,
  CCTerminal.TerminalType.YOMANI,
];

/*
These gateways are supported but for Retail Manager only.
 */
_SupportedTerminals[GatewayConfig.GatewayType.BARCLAYCARD] = [];
_SupportedTerminals[GatewayConfig.GatewayType.BNP_PARIBAS] = [];
_SupportedTerminals[GatewayConfig.GatewayType.CONCARDIS] = [];
_SupportedTerminals[GatewayConfig.GatewayType.IZETTLE] = [];
_SupportedTerminals[GatewayConfig.GatewayType.WORLDLINE] = [];

/*
Maintains the list of gateways that support refunds by reference ID
 */
const _SupportsRefundByReference = [
  GatewayConfig.GatewayType.CAYAN,
  GatewayConfig.GatewayType.ELEMENT_EXPRESS,
  GatewayConfig.GatewayType.LIGHTSPEED_PAYMENTS,
  GatewayConfig.GatewayType.MERCURY_PAYMENT_SYSTEMS,
  GatewayConfig.GatewayType.VANTIV_US,
  GatewayConfig.GatewayType.VANTIV_TRIPOS,
];

/*
List of gateways that support cancellation via the POS
 */
const _SupportsCancelFromPOS = [GatewayConfig.GatewayType.CAYAN];

/**
 * List of gateways that support manual entry from a terminal
 */
const _SupportsManualEntryFromTerminal = {};
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.VANTIV_TRIPOS] = true;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.ELEMENT_EXPRESS] = false;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.IZETTLE] = false;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.MERCURY_CANADA] = false;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.MERCURY_EMV] = false;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.MERCURY_PAYMENT_SYSTEMS] = false;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.TYRO] = false;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.VANTIV_US] = false;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.VANTIV_CANADA] = false;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.VANTIV_TRIPOS] = true;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.WORLDLINE] = false;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.BARCLAYCARD] = false;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.BNP_PARIBAS] = false;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.CONCARDIS] = false;
_SupportsManualEntryFromTerminal[GatewayConfig.GatewayType.FIRST_DATA] = false;

/**
 * List of gateways that support manual entry for refund from a terminal
 */
const _SupportsManualEntryTerminalRefund = {};
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.VANTIV_TRIPOS] = true;
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.ELEMENT_EXPRESS] = false;
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.IZETTLE] = false;
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.MERCURY_CANADA] = false;
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.MERCURY_EMV] = false;
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.MERCURY_PAYMENT_SYSTEMS] = false;
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.TYRO] = false;
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.VANTIV_US] = false;
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.VANTIV_CANADA] = false;
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.WORLDLINE] = false;
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.BARCLAYCARD] = false;
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.BNP_PARIBAS] = false;
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.CONCARDIS] = false;
_SupportsManualEntryTerminalRefund[GatewayConfig.GatewayType.FIRST_DATA] = false;
/*
Maintains the list of gateways that support Manual Entry in POS
 */
const _SupportsManualEntry = {};
_SupportsManualEntry[GatewayConfig.GatewayType.CAYAN] = true;
_SupportsManualEntry[GatewayConfig.GatewayType.ELEMENT_EXPRESS] = true;
_SupportsManualEntry[GatewayConfig.GatewayType.MERCURY_PAYMENT_SYSTEMS] = true;
_SupportsManualEntry[GatewayConfig.GatewayType.IZETTLE] = false;
_SupportsManualEntry[GatewayConfig.GatewayType.VANTIV_TRIPOS] = false;
_SupportsManualEntry[GatewayConfig.GatewayType.MERCURY_CANADA] = false;
_SupportsManualEntry[GatewayConfig.GatewayType.MERCURY_EMV] = false;
_SupportsManualEntry[GatewayConfig.GatewayType.TYRO] = false;
_SupportsManualEntry[GatewayConfig.GatewayType.VANTIV_US] = false;
_SupportsManualEntry[GatewayConfig.GatewayType.VANTIV_CANADA] = false;
_SupportsManualEntry[GatewayConfig.GatewayType.WORLDLINE] = false;
_SupportsManualEntry[GatewayConfig.GatewayType.BARCLAYCARD] = false;
_SupportsManualEntry[GatewayConfig.GatewayType.BNP_PARIBAS] = false;
_SupportsManualEntry[GatewayConfig.GatewayType.CONCARDIS] = false;
_SupportsManualEntry[GatewayConfig.GatewayType.FIRST_DATA] = false;

const _SupportsCreditRefunds = {};
_SupportsCreditRefunds[GatewayConfig.GatewayType.CAYAN] = true;
_SupportsCreditRefunds[GatewayConfig.GatewayType.ELEMENT_EXPRESS] = true;
_SupportsCreditRefunds[GatewayConfig.GatewayType.FIRST_DATA] = true;
_SupportsCreditRefunds[GatewayConfig.GatewayType.IZETTLE] = false;
_SupportsCreditRefunds[GatewayConfig.GatewayType.LIGHTSPEED_PAYMENTS] = true;
_SupportsCreditRefunds[GatewayConfig.GatewayType.MERCURY_EMV] = true;
_SupportsCreditRefunds[GatewayConfig.GatewayType.MERCURY_PAYMENT_SYSTEMS] = true;
_SupportsCreditRefunds[GatewayConfig.GatewayType.TYRO] = true;
_SupportsCreditRefunds[GatewayConfig.GatewayType.VANTIV_US] = true;
_SupportsCreditRefunds[GatewayConfig.GatewayType.VANTIV_CANADA] = true;
_SupportsCreditRefunds[GatewayConfig.GatewayType.VANTIV_TRIPOS] = true;
_SupportsCreditRefunds[GatewayConfig.GatewayType.WORLDLINE] = false;
_SupportsCreditRefunds[GatewayConfig.GatewayType.BARCLAYCARD] = false;
_SupportsCreditRefunds[GatewayConfig.GatewayType.BNP_PARIBAS] = false;
_SupportsCreditRefunds[GatewayConfig.GatewayType.CONCARDIS] = false;

const _SupportsUSBSwipe = {};
_SupportsUSBSwipe[GatewayConfig.GatewayType.BARCLAYCARD] = false;
_SupportsUSBSwipe[GatewayConfig.GatewayType.BNP_PARIBAS] = false;
_SupportsUSBSwipe[GatewayConfig.GatewayType.CONCARDIS] = false;
_SupportsUSBSwipe[GatewayConfig.GatewayType.CAYAN] = true;
_SupportsUSBSwipe[GatewayConfig.GatewayType.FIRST_DATA] = false;
_SupportsUSBSwipe[GatewayConfig.GatewayType.IZETTLE] = false;
_SupportsUSBSwipe[GatewayConfig.GatewayType.LIGHTSPEED_PAYMENTS] = false;
_SupportsUSBSwipe[GatewayConfig.GatewayType.ELEMENT_EXPRESS] = true;
_SupportsUSBSwipe[GatewayConfig.GatewayType.MERCURY_PAYMENT_SYSTEMS] = true;
_SupportsUSBSwipe[GatewayConfig.GatewayType.MERCURY_EMV] = false;
_SupportsUSBSwipe[GatewayConfig.GatewayType.VANTIV_TRIPOS] = false;
_SupportsUSBSwipe[GatewayConfig.GatewayType.TYRO] = false;
_SupportsUSBSwipe[GatewayConfig.GatewayType.VANTIV_US] = false;
_SupportsUSBSwipe[GatewayConfig.GatewayType.VANTIV_CANADA] = false;
_SupportsUSBSwipe[GatewayConfig.GatewayType.WORLDLINE] = false;

/**
 * List of gateways supporting integrated refunds
 *
 * @type {{}}
 * @private
 */
const _SupportsIntegratedRefunds = {};
_SupportsIntegratedRefunds[GatewayConfig.GatewayType.LIGHTSPEED_PAYMENTS] = true;
_SupportsIntegratedRefunds[GatewayConfig.GatewayType.VANTIV_US] = true;
_SupportsIntegratedRefunds[GatewayConfig.GatewayType.VANTIV_TRIPOS] = true;

/**
 * List of gateways supporting refunds using negative payments
 */
const _SupportsNegativePaymentRefunds = {};
_SupportsNegativePaymentRefunds[GatewayConfig.GatewayType.TYRO] = true;

/*
Parameter mapping to normalize form data to a Payload that the API needs
 */
const _ManualEntryMapping = [
  {
    formName: 'f_name',
    payloadName: 'firstName',
  },
  {
    formName: 'l_name',
    payloadName: 'lastName',
  },
  {
    formName: 'company',
    payloadName: 'company',
  },
  {
    formName: 'address',
    payloadName: 'address1',
    contactSection: true,
  },
  {
    formName: 'address2',
    payloadName: 'address2',
    contactSection: true,
  },
  {
    formName: 'city',
    payloadName: 'city',
    contactSection: true,
  },
  {
    formName: 'state',
    payloadName: 'state',
    contactSection: true,
  },
  {
    formName: 'zip',
    payloadName: 'zip',
    contactSection: true,
  },
  {
    formName: 'country',
    payloadName: 'country',
    contactSection: true,
  },
  {
    formName: 'phone',
    payloadName: 'phoneHome',
    contactSection: true,
  },
];

export default class PaymentProvider extends BaseObject {
  /**
   * Constructor for a PaymentProvider object.
   *
   * @param {GatewayConfig} gateway  The active gateway that is configured for a shop
   * @param {CCTerminalCollection} terminalCollection  A collection of the configured terminals for a shop
   * @param {boolean} [canRetrieveGateway] Use to tell if the gateway information could be retrieved from the Pay Service
   *
   */
  constructor(gateway, terminalCollection, canRetrieveGateway = true) {
    super();

    this._canRetrieveGateway = canRetrieveGateway;

    if (gateway instanceof GatewayConfig && terminalCollection instanceof CCTerminalCollection) {
      this._initData(gateway, terminalCollection);
    } else {
      throw 'A gateway and terminal collection is required to instantiate a PaymentProvider object.';
    }
  }

  /**
   * Convenience method to obtain an instance of a PaymentProvider object for the current shop.
   * It takes care of formulating the appropriate fetch of the data and resolves with a new
   * PaymentProvider object.
   *
   * @returns {jQuery.Promise}    Resolves with a PaymentProvider object if successful
   */
  static getCurrentShopPaymentProvider() {
    return PaymentProvider.getShopPaymentProvider(CommonData.selectedShop);
  }

  /**
   * Convenience method to obtain an instance of a PaymentProvider object for any shop.
   * It takes care of formulating the appropriate fetch of the data and resolves with a new
   * PaymentProvider object.
   *
   * @param {Shop} shop   The shop
   * @returns {jQuery.Promise}    Resolves with a PaymentProvider object if successful
   */
  static getShopPaymentProvider(shop) {
    let deferred = $.Deferred();
    let gatewayConfigID = shop.get('gatewayConfigID');
    let gatewayConfig = new GatewayConfig({
      // if a valid gatewayConfigID is present then use that instead of the deprecated ccGatewayID
      gatewayConfigID:
        gatewayConfigID && gatewayConfigID.match && gatewayConfigID.match(/-/)
          ? gatewayConfigID
          : shop.get('ccGatewayID'),
    });
    let ccTerminals = new CCTerminalCollection();
    let canRetrieveGateway = true;

    // FIXME: CLD-31181
    // This gateway check never worked since gatewayConfig.id
    // is an integer and the "match" method is only available on
    // a string. We will need to validate that no merchants are
    // still using numerical ids before changing this logic.
    const isInvalidConfigID =
      !gatewayConfig.id || (gatewayConfig.id.match && !gatewayConfig.id.match(/-/));
    let gatewayDeferred = $.Deferred();

    if (isInvalidConfigID) {
      // no gateway is set for the shop
      gatewayConfig = new GatewayConfig();
      gatewayDeferred.resolve();
    } else {
      gatewayConfig
        .fetch()
        .done(() => {
          gatewayDeferred.resolve();
        })
        .fail(({ status }) => {
          // if the status is over >= 400 we assume this is
          // a cause for Payment Service degradation and set
          // the canRetrieveGateway to false

          // FIXME: CLD-31181
          // Temporary fix to ignore issue cause by the isInvalidConfigID
          // check that leads to 404.
          if (status >= 400 && status !== 404) {
            canRetrieveGateway = false;
          }

          // if the fetch fails, just specify an empty gateway config;
          // this will allow the payment provider to detect that there
          // is no valid gateway configuration for this shop
          gatewayConfig = new GatewayConfig();
          gatewayDeferred.resolve();
        });
    }

    let terminalDeferred = $.Deferred();
    ccTerminals.fetch().always(() => {
      // always return a collection even if the fetch fails
      terminalDeferred.resolve();
    });

    $.when(gatewayDeferred, terminalDeferred).done(() => {
      deferred.resolve(new PaymentProvider(gatewayConfig, ccTerminals, canRetrieveGateway));
    });

    return deferred.promise();
  }

  /**
   * Checks to see if the given Gateway has any terminals assigned to it
   * @param gateway
   * @returns {boolean}
   */
  static gatewayHasTerminals(gatewayConfig) {
    let deferred = $.Deferred();
    let ccTerminals = new CCTerminalCollection();
    $.when(ccTerminals.fetch()).always(() => {
      let gatewayConfigID = gatewayConfig.id;

      // Check to see if any terminals are assigned to this gateway
      let configuredTerminals = ccTerminals.where({ gatewayConfigID });

      deferred.resolve(configuredTerminals.length > 0);
    });

    return deferred;
  }

  /**
   * Checks to see if the given Gateway can do a Refund by Reference
   * @param gateway
   * @returns {boolean}
   */
  static gatewaySupportsRefundByReference(gatewayConfig) {
    let supportsRefundByReference = false;

    if (gatewayConfig) {
      supportsRefundByReference = !isUndefined(
        find(
          _SupportsRefundByReference,
          gatewayType => gatewayConfig.get('gatewayID') === gatewayType
        )
      );
    }

    return supportsRefundByReference;
  }

  /**
   * Expected to only be used for Lightspeed Payments gateway configurations.
   * Returns a list of features that the predominant processor may or may not support.
   *
   * @param {GatewayConfig} gatewayConfig     The gateway to check
   * @returns {{supportAllowCredits: *, supportPartialApprovals: *, supportPreventDuplicates: *, supportInterac, supportApiCancel}}
   */
  static supportedFeaturesForGateway(gatewayConfig) {
    let featuresForGateway = null;

    if (gatewayConfig) {
      const supportedFeatures = get(gatewayConfig, 'supportedFeatures', null);

      if (supportedFeatures) {
        featuresForGateway = JSON.parse(supportedFeatures);
      }
    }

    return {
      supportAllowCredits: get(featuresForGateway, 'negative-payments', false),
      supportPartialApprovals: get(featuresForGateway, 'partial-approvals', false),
      supportPreventDuplicates: get(featuresForGateway, 'duplicate-transaction-check', false),
      supportInterac: get(featuresForGateway, 'interac', false),
      supportBancontact: get(featuresForGateway, 'bancontact', false),
      supportIdeal: get(featuresForGateway, 'ideal', false),
      supportManualEntry: get(featuresForGateway, 'manual-entry', false),
      supportManualEntryTerminal: get(featuresForGateway, 'manual-entry-terminal', false),
      supportsManualEntryTerminalRefund: get(
        featuresForGateway,
        'manual-entry-terminal-refund',
        false
      ),
      supportMagstripeFallback: get(featuresForGateway, 'magstripe-fallback', false),
      supportApiCancel: get(featuresForGateway, 'cancel-from-pos', false),
    };
  }

  /**
   * Returns a list of terminals supported by the gateway.
   *
   * @param {GatewayConfig} gatewayConfig     The gateway to check
   * @returns {Array|null}
   */
  static supportedTerminalsForGateway(gatewayConfig) {
    let supportedTerminalsForGateway = null;

    if (gatewayConfig) {
      supportedTerminalsForGateway = get(_SupportedTerminals, gatewayConfig.get('gatewayID'), null);
    }

    return supportedTerminalsForGateway;
  }

  /**
   * Retrieves the processor type (i.e. gatewayID) from the active gateway
   */
  get activeGatewayProcessorType() {
    return get(this._activeGateway, 'attributes.gatewayID');
  }

  /**
   * Retrieves if the current gateway information can be retrieve from the
   * Payment Service
   */
  get canRetrieveGateway() {
    return this._canRetrieveGateway;
  }

  /**
   * Retrieves the active gateway configured for the shop.
   *
   * @returns {GatewayConfig|null} The active gateway for the current shop or null
   */
  get activeGateway() {
    return this._activeGateway;
  }

  /**
   * Retrieves the terminals configured for the shop.
   *
   * @returns {Array} A list of terminal objects that conform to the ITerminal interface.
   */
  get terminals() {
    return this._terminals;
  }

  /**
   * Retrieves the raw terminal collection configured for the shop.
   *
   * @returns {*}
   */
  get terminalCollection() {
    let terminalCollection = new CCTerminalCollection();

    this._terminals.forEach(terminal => {
      terminalCollection.add(terminal.model);
    });

    return terminalCollection;
  }

  /**
   * Retrieves a list of the terminals supported by the active gateway.  If there is no active
   * gateway or the gateway does not support terminals then null is returned.
   *
   * @returns {Array|null}    A list of terminal types (CCTerminal.TerminalType) supported by the
   *                          gateway.  Returns null if terminals are not supported or no gateway
   *                          is configured.
   */
  get activeGatewaySupportedTerminals() {
    return PaymentProvider.supportedTerminalsForGateway(this.activeGateway);
  }

  /**
   * Retrieves whether the active gateway supports refunds by reference
   *
   * @returns {boolean}   True if the the active gateway can refund by reference
   */
  get activeGatewaySupportsRefundByReference() {
    return PaymentProvider.gatewaySupportsRefundByReference(this.activeGateway);
  }

  activeGatewayHasConfiguredTerminals() {
    return this._terminals.length > 0;
  }

  /**
   * Retrieves whether the active gateway supports USB Swipe
   *
   * @returns {boolean}  True if the the active gateway supports USB Swipe
   */
  activeGatewaySupportsUSBSwipe() {
    let supportsUSBSwipe = false;

    if (
      this.activeGateway &&
      !isUndefined(_SupportsManualEntry[this.activeGateway.get('gatewayID')])
    ) {
      supportsUSBSwipe =
        _SupportsUSBSwipe[this.activeGateway.get('gatewayID')] ||
        this.activeGatewayHasIntegratedSwipeSupport();
    }

    return supportsUSBSwipe;
  }

  /**
   * Retrieves the Mapping for the formData against the Payload
   *
   * @returns {Array}   Returns an Array of Objects which maps the form parameter name to the payload parameter name
   */
  get manualEntryMapping() {
    return _ManualEntryMapping;
  }

  /**
   * Retrieves whether the active gateway supports cancellation via the POS
   *
   * @returns {boolean}   True if the the active gateway can cancel an in progress
   *                      transaction from the POS
   */
  get activeGatewaySupportsCancelFromPOS() {
    let supportsCancel = false;

    if (this.activeGateway) {
      supportsCancel = !isUndefined(
        find(
          _SupportsCancelFromPOS,
          gatewayType => this.activeGateway.get('gatewayID') === gatewayType
        )
      );
    }

    return supportsCancel;
  }

  /**
   * Retrieves whether the active gateway supports credit card refunds at all.
   *
   * @returns {boolean}
   */
  get activeGatewaySupportsRefunds() {
    let supportsRefunds = false;

    if (this.activeGateway) {
      supportsRefunds = _SupportsCreditRefunds[this.activeGateway.get('gatewayID')] === true;
    }

    return supportsRefunds;
  }

  /**
   * Retrieves whether the active gateway supports voiding throught the Retail API
   *
   * @returns {boolean}   True if the active gateway may be voided using the Retail API
   */
  get activeGatewaySupportsIntegratedRefunds() {
    let supportsRefunds = false;

    if (this.activeGateway) {
      supportsRefunds = _SupportsIntegratedRefunds[this.activeGateway.get('gatewayID')] === true;
    }

    return supportsRefunds;
  }

  /**
   * Retrieves whether the active gateway support refunding with negative payments while in
   * a sale.
   *
   * @returns {boolean}   True if the active gateway allows refunding in sale payments with negated payments
   */
  get activeGatewayAllowsNegativePaymentRefunds() {
    let supportsNegativePaymentRefunds = false;

    if (this.activeGateway) {
      supportsNegativePaymentRefunds =
        _SupportsNegativePaymentRefunds[this.activeGateway.get('gatewayID')] === true;
    }

    return supportsNegativePaymentRefunds;
  }

  /**
   * Retrieves whether the active gateway supports manual card entry from the terminal.
   *
   * @returns {boolean}   True if the gateway supports manual card entry from the terminal
   */
  get activeGatewaySupportsManualEntryFromTerminal() {
    let supportsManualEntryFromTerminal = false;

    if (this.activeGateway) {
      const supportedFeatures = PaymentProvider.supportedFeaturesForGateway(
        get(this.activeGateway, 'attributes', {})
      );

      const activeGatewayID = this.activeGateway.get('gatewayID');
      supportsManualEntryFromTerminal =
        !!supportedFeatures.supportManualEntryTerminal ||
        !!_SupportsManualEntryFromTerminal[activeGatewayID];
    }
    return supportsManualEntryFromTerminal;
  }

  /**
   * Retrieves whether the active gateway supports manual card entry from the POS.
   *
   * @returns {boolean}   True if the gateway supports manual card entry from the POS
   */
  get activeGatewaySupportsManualEntry() {
    let supportsManualEntry = false;

    if (this.activeGateway) {
      const supportedFeatures = PaymentProvider.supportedFeaturesForGateway(
        get(this.activeGateway, 'attributes', {})
      );

      const activeGatewayID = this.activeGateway.get('gatewayID');
      supportsManualEntry =
        !!supportedFeatures.supportManualEntry || !!_SupportsManualEntry[activeGatewayID];
    }
    return supportsManualEntry;
  }

  /**
   * Retrieves whether the active gateway is an iOS only gateway
   */
  get activeGatewayIosOnly() {
    return this.activeGatewaySupportedTerminals
      ? this.activeGatewaySupportedTerminals.length === 0
      : false;
  }

  /**
   * Retrieves whether the active gateway supports manual entry for refunds
   * @returns {boolean}   True if the gateway supports manual card entry refund from the POS
   */
  get supportsManualEntryTerminalRefund() {
    let supportsManualEntry = false;
    if (this.activeGateway) {
      const supportedFeatures = PaymentProvider.supportedFeaturesForGateway(
        get(this.activeGateway, 'attributes', {})
      );

      const activeGatewayID = this.activeGateway.get('gatewayID');

      supportsManualEntry =
        !!supportedFeatures.supportsManualEntryTerminalRefund ||
        !!_SupportsManualEntryTerminalRefund[activeGatewayID];
    }
    return supportsManualEntry;
  }

  /**
   * Retrieves a terminal object for the specified terminal ID.
   *
   * @param {String} terminalID    The ID of the terminal as per the API.
   * @returns {ITerminal} The terminal object.
   */
  getTerminal(terminalID) {
    let terminal = null;

    if (this.terminals) {
      terminal = find(this.terminals, terminal => terminal.model.id === terminalID) || null;
    }

    return terminal;
  }

  /**
   * Returns if all of the Payment Types for the Active Gateway Require a Customer to be Attached to the Sale
   *
   * @returns {Boolean}  True if all of the Payment Types Require Customer to be attached to the Sale
   */
  activeGatewayRequiresCustomer() {
    let cardMappingCustomerRequired = [];
    this._activeGateway.get('cardSchemeMappings').CardSchemeMapping.forEach(paymentTypeMapping => {
      let paymentType = PaymentTypeManager.getPaymentType(
        parseInt(paymentTypeMapping.paymentTypeID)
      );
      cardMappingCustomerRequired.push(paymentType.get('requireCustomer'));
    });
    return cardMappingCustomerRequired.every(
      customerRequiredForPaymentType => customerRequiredForPaymentType === true
    );
  }

  activeGatewayHasIntegratedSwipeSupport() {
    return (
      Modules.hasModule('payments.settings.allowswipers') &&
      get(this.activeGateway.get('parameters'), 'swipersEnabled') === 'true'
    );
  }

  /**
   * Sets data which are accessible via the object properties activeGateway and terminals.
   *
   * @param {GatewayConfig} gateway   The selected gateway for the shop
   * @param {CCTerminalCollection} terminalCollection  The terminals configured for the shop.
   * @private
   */
  _initData(gateway, terminalCollection) {
    this._activeGateway = !gateway.isNew() ? gateway : null;
    this._terminals = [];

    if (
      this._activeGateway &&
      this._activeGateway.get('gatewayID') === GatewayConfig.GatewayType.TYRO
    ) {
      // prefetch Tyro API files for optimal performance
      TyroTerminalService.getInstance();
    }

    if (
      this._activeGateway &&
      this._activeGateway.get('gatewayID') === GatewayConfig.GatewayType.LIGHTSPEED_PAYMENTS
    ) {
      // prefetch Stripe API files for optimal performance
      StripeTerminalService.getInstance();
    }

    if (terminalCollection && terminalCollection.length) {
      terminalCollection.forEach(terminal => {
        if (this._activeGateway && terminal.get('gatewayConfigID') === this._activeGateway.id) {
          let concreteTerminal = TerminalFactory.createTerminal(
            this._activeGateway.get('gatewayID'),
            terminal
          );
          if (concreteTerminal) {
            this._terminals.push(concreteTerminal);
          }
        }
      });
    }
  }
}
